import { Component } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { GText } from '../volkswagen.types';

@Component({
  selector: 'app-xml-g-text',
  standalone: true,
  template: `
    <p class="my-2 text-sm">
      {{ data.text }}
      <!-- @if (data.icon === 'hinweis') {
        <span class="inline-flex items-center font-medium text-blue-600">
          {{ data.text }}
        </span>
      } @else { -->
      <!-- <span class="text-gray-700">{{ data.text }}</span> -->
      <!-- } -->

      @if (data.children && data.children.length > 0) {
        <span class="ml-1 text-xs text-gray-500">({{ data.children.length }})</span>
      }
    </p>
  `,
})
export class GTextComponent extends XMLElementBaseComponent<GText> {}
